// Droits du dashboard : masque de bits par module, comme les droits Unix
// (1 = lecture, 2 = écriture, 4 = accès / admin ; 7 = les trois)

export function canRead(permissions, module)
{
	if (!permissions || !permissions[module])
		return false
	return permissions[module] % 2 === 1
}

export function canWrite(permissions, module)
{
	if (!permissions || !permissions[module])
		return false
	return (permissions[module] & 2) === 2
}

// Décision 20 (inventaires staff) : le bouton « Dashboard » d'un écran terrain
// ne s'affiche que si l'utilisateur a accès à au moins un autre module
export function hasOtherModules(permissions, currentModule)
{
	if (!permissions)
		return false
	return Object.keys(permissions).some(key => key !== currentModule && canRead(permissions, key))
}
